import { HostListener, Directive } from '@angular/core';
import { CartNavigatorService } from '~shared/modules/cart-navigator/cart-navigator.service';

@Directive({
  selector: '[cartLink]',
})
export class CartLinkDirective {
  constructor
  (
    private readonly cartNavigator: CartNavigatorService,
  ) {
  }

  @HostListener('click', ['$event'])
  public onClick(e): boolean {
    e.stopPropagation();
    e.preventDefault();

    this.cartNavigator.navigateToCart().subscribe();

    return false;
  }
}
